module.exports = __webpack_public_path__ + "img/suto-bg.184edad7.jpg";